// extracted by mini-css-extract-plugin
export default {"lead":"JobBoardApplySuccessModal_lead__-1YS9","list":"JobBoardApplySuccessModal_list__DDvlR"};